<div class="modal-body justify-content-center">
  <div class="cm-header-section">
    <h5 class="modal-title" id="reviewModalLabel">{{constants.modalTitle}}</h5>
    <button (click)="closeModal()" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
      <span class="cm-close-text">{{constants.close}}</span>
    </button>
  </div>

  <div class="si-container">
    <app-studio-inquiry-sidebar [activeStep]="4"></app-studio-inquiry-sidebar>

    <div class="si-application">
      <div class="si-section rv-card">
        <div class="rv-row" *ngFor="let section of sections; let last = last" [class.rv-row-last]="last">
          <h2 class="rv-row-title">{{section.title}}</h2>

          <div class="rv-row-data">
            <div class="rv-group" *ngFor="let group of section.groups">
              <div class="rv-line" *ngFor="let line of group">
                <span class="rv-label" *ngIf="line.label">{{line.label}}</span>

                <span class="rv-value" *ngIf="line.value">
                  {{line.value}}
                  <span class="rv-note" *ngIf="line.note">{{line.note}}</span>
                </span>

                <span class="rv-value" *ngIf="line.lines">
                  <span class="rv-value-line" *ngFor="let text of line.lines">{{text}}</span>
                </span>
              </div>
            </div>
          </div>

          <a class="si-link rv-edit" tabindex="0" (click)="onEdit(section.target)"
            (keydown.enter)="onEdit(section.target)"
            (keydown.space)="onEdit(section.target)">{{constants.edit}}</a>
        </div>
      </div>

      <div class="si-buttons">
        <div class="si-back">
          <img src="../assets/images/blue-left-icon.svg" alt="" class="si-back-icon">
          <a class="text-link si-back-link" tabindex="0" (click)="onBack()" (keydown.enter)="onBack()"
            (keydown.space)="onBack()">{{constants.back}}</a>
        </div>
        <button type="button" class="btn common-btn-secondary" (click)="onSubmit()">{{constants.submit}}</button>
      </div>
    </div>
  </div>
</div>
